<div class="chatbody" #chatContainer style="height: 400px; overflow-y: auto;">
  <div class="text-gray-500 my-5 w-100 text-center" *ngIf="messages.length == 0">
    No conversation yet
  </div>
  <div class="recieverMessageCont">
    <div class="d-block mb-1" *ngFor="let msg of messages; let i = index">
      <div class="d-block">
        <div class="d-flex align-items-center gap-2 mb-2" *ngIf="receiveMsgData?.helperId == msg?.send_by">
          <div class="d-block">
            <span *ngIf="i === 0 || messages[i - 1]?.send_to !== msg?.send_to" class="text-gray-500 fs-9 mt-5">{{
              msg?.sent_at }}</span>
            <div class="fs-7 py-2 px-4 rounded bg-light-info text-gray-900 fw-semibold mw-sm-250px text-start"
              style="word-break: break-word; white-space: pre-wrap;">
              {{ msg?.text }}
            </div>
          </div>
        </div>
      </div>
      <div class="senderMessageCont">
        <div class="d-block mb-1" *ngIf="receiveMsgData?.userId == msg?.send_by">
          <div class="d-flex align-items-center justify-content-end gap-2 mb-2">
            <div class="d-block">
              <span *ngIf="i === 0 || messages[i - 1]?.send_by !== msg?.send_by" class="text-gray-500 fs-9 mt-5">{{
                msg?.sent_at }}</span>
              <div class="fs-7 py-2 px-4 rounded bg-light-primary text-gray-900 fw-semibold mw-sm-250px text-end"
                style="word-break: break-word; white-space: pre-wrap;">
                {{ msg?.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="chatFooter d-flex align-items-start gap-2 mt-5">
  <div class="w-100">
    <textarea class="d-block w-100 mh-50px flex-fill form-control" [(ngModel)]="sendMsg" maxlength="200"
      [placeholder]=" 'WRITE_MESSAGE_WITH_LIMIT' | translate " (keydown.enter)="sendMessage()"></textarea>
    <div class="text-danger fs-8 mt-1" *ngIf="sendMsg && sendMsg.length >= 200">
      {{'MESSAGE_CANNOT_EXCEED_200_CHARACTERS' | translate}}
    </div>
  </div>
  <button class="btn btn-primary d-flex align-items-center justify-content-center w-40px h-100" (click)="sendMessage()"
    [disabled]="sendMsg && sendMsg.length > 200">
    <span class="d-flex flex-column w-25px text-white">
      <img class="w-25px text-white" src="../../assets/img/send.svg" alt="">
    </span>
  </button>
</div>
